/**
https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Operators/typeof

Undefined	"undefined"
Null	"object"（原因）
Boolean	"boolean"
Number	"number"
BigInt	"bigint"
String	"string"
Symbol	"symbol"
Function（在 ECMA-262 中实现 [[Call]]；classes也是函数)	"function"
其他任何对象	"object"
 */
export const TYPEOF = {
  NULL: "null",
  Array: "array",
  Object: "object",
  Undefined: "undefined",
  Boolean: "boolean",
  Number: "number",
  BigInt: "bigint",
  String: "string",
  Symbol: "symbol",
  Function: "function"
};

// 判断数据类型
export const typeofStr = any => {
  if (any == null) {
    return TYPEOF.NULL;
  } else if (any instanceof Array) {
    return TYPEOF.Array;
  } else if (any instanceof Function) {
    return TYPEOF.Function;
  } else if (any instanceof Object) {
    return TYPEOF.Object;
  } else {
    return typeof any;
  }
};

// 深拷贝对象
export const deepCopy = obj => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }

  let copy = Array.isArray(obj) ? [] : {};

  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      copy[key] = deepCopy(obj[key]);
    }
  }

  return copy;
};



// WEBPACK FOOTER //
// ./src/utils/common.js